export enum Color {
  Black = 'black',
  White = 'white',
}
